import { css } from 'aphrodite';
import * as React from 'react';
import { INameValue, ValueSelector } from '../ValueSelector';
import StatesCollection from './states.json';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	onSelectionChanged?(selected: INameValue): void;
	selectedValue?: string;
}

export const ExtendedUSStates = StatesCollection as INameValue[];

// The Campaign Registry (TCR) supports every US state & territory in states.json except
// Palau, so exclude it from the states offered during 10DLC text registration.
export const TcrSupportedStates: INameValue[] = ExtendedUSStates.filter(s => s.value !== 'PW');

export const StateSelector: React.FC<IProps> = props => {
	const { className, ...restProps } = props;

	return (
		<ValueSelector
			className={`${css(styleSheet.container)} state-selector ${className || ''}`}
			options={ExtendedUSStates}
			{...restProps}
		/>
	);
};
